import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_BatchUploadModal = _resolveComponent("BatchUploadModal")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_snackbar, {
        color: "success",
        modelValue: _ctx.showParticipantAddedMessage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showParticipantAddedMessage) = $event)),
        timeout: "2000"
      }, {
        default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
          _createTextVNode("Participant added!", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_ValidationAlert, { "validation-results": _ctx.validationMessages }, null, 8, ["validation-results"]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            flat: ""
          }, {
            default: _withCtx(() => [
              (_ctx.saveResults && _ctx.saveResults.isValid)
                ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar, {
                        color: "secondary",
                        class: "mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                              _createTextVNode("Entry Results", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_data_table, {
                            headers: _ctx.resultHeaders,
                            items: _ctx.saveResults.results,
                            density: "compact",
                            class: "elevation-1"
                          }, {
                            [`item.status`]: _withCtx(({ item }) => [
                              _createVNode(_component_v_chip, {
                                color: item.isSuccessful ? 'success' : 'error'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.isSuccessful ? "Success" : "Failed"), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            [`item.phaseStartDate`]: _withCtx(({ item }) => [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(item.phaseStartDate)), 1)
                            ]),
                            [`item.phaseEndDate`]: _withCtx(({ item }) => [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(item.phaseEndDate)), 1)
                            ]),
                            [`item.details`]: _withCtx(({ item }) => [
                              _createVNode(_component_v_list, {
                                density: "compact",
                                items: item.messages
                              }, null, 8, ["items"])
                            ]),
                            _: 2
                          }, 1032, ["headers", "items"]),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                align: "center",
                                class: "mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    color: "primary",
                                    onClick: _ctx.resetPage
                                  }, {
                                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                      _createTextVNode("Begin New Entry", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"])), [
                                    [_directive_ripple]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.saveResults || !_ctx.saveResults.isValid)
                ? (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, {
                            ref: "form",
                            modelValue: _ctx.isFormValid,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.isFormValid) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    lg: "8"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_toolbar, {
                                        color: "secondary",
                                        class: "mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                                            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                              _createTextVNode("Batch Entry Data", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select, {
                                                items: _ctx.phaseSectionList,
                                                "item-value": "id",
                                                "item-title": "description",
                                                label: "Select Category",
                                                rules: _ctx.requiredRules,
                                                "onUpdate:modelValue": _ctx.onCategoryChanged
                                              }, null, 8, ["items", "rules", "onUpdate:modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "6"
                                          }, {
                                            default: _withCtx(() => [
                                              (_ctx.isBehaviorResponse)
                                                ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                                    key: 0,
                                                    modelValue: _ctx.behaviorTypeFilter,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.behaviorTypeFilter) = $event)),
                                                    label: "Filter by Behavior Type"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_radio, {
                                                        label: "Inappropriate",
                                                        value: "negative"
                                                      }),
                                                      _createVNode(_component_v_radio, {
                                                        label: "Both",
                                                        value: "both"
                                                      }),
                                                      _createVNode(_component_v_radio, {
                                                        label: "Positive",
                                                        value: "positive"
                                                      })
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              (!_ctx.isDrugTest)
                                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                    key: 0,
                                                    type: "date",
                                                    label: "Start Date",
                                                    modelValue: _ctx.entry.startDateForEdit,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entry.startDateForEdit) = $event)),
                                                    rules: _ctx.isDrugTest ? [] : _ctx.requiredRules
                                                  }, null, 8, ["modelValue", "rules"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.isDrugTest)
                                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                    key: 1,
                                                    type: "date",
                                                    label: "Test Date",
                                                    modelValue: _ctx.entry.datePerformedForEdit,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.entry.datePerformedForEdit) = $event))
                                                  }, null, 8, ["modelValue"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              (!_ctx.isDrugTest)
                                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                    key: 0,
                                                    type: "date",
                                                    label: "End Date",
                                                    modelValue: _ctx.entry.endDateForEdit,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.entry.endDateForEdit) = $event))
                                                  }, null, 8, ["modelValue"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.isDrugTest)
                                                ? (_openBlock(), _createBlock(_component_v_select, {
                                                    key: 1,
                                                    modelValue: _ctx.entry.drugTestLocationId,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entry.drugTestLocationId) = $event)),
                                                    items: _ctx.drugTestLocations,
                                                    "item-value": "id",
                                                    "item-title": "description",
                                                    label: "Location"
                                                  }, null, 8, ["modelValue", "items"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              (_ctx.isCustodyResidential)
                                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                    key: 0,
                                                    type: "date",
                                                    label: "Target End Date",
                                                    modelValue: _ctx.entry.targetEndDateForEdit,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.entry.targetEndDateForEdit) = $event))
                                                  }, null, 8, ["modelValue"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.showLocationOther)
                                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                    key: 1,
                                                    required: _ctx.showLocationOther,
                                                    rules: _ctx.showLocationOther ? _ctx.requiredRules : [],
                                                    modelValue: _ctx.entry.drugTestLocationOther,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.entry.drugTestLocationOther) = $event)),
                                                    label: "Specify Location"
                                                  }, null, 8, ["required", "rules", "modelValue"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.statusList.length > 0 || _ctx.typeList.length > 0)
                                        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "6"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.isCourtAttendance)
                                                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                                        key: 0,
                                                        modelValue: _ctx.entry.ftaWarrantyIssued,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.entry.ftaWarrantyIssued) = $event)),
                                                        label: "Failure to Appear (FTA) Warranty Issued"
                                                      }, null, 8, ["modelValue"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "6"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.typeList.length > 0)
                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                        key: 0,
                                                        items: _ctx.typeList,
                                                        "item-value": "id",
                                                        "item-title": "description",
                                                        label: "Select Type",
                                                        modelValue: _ctx.entry.typeId,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.entry.typeId) = $event)),
                                                        rules: _ctx.typeList.length > 0 ? _ctx.requiredRules : []
                                                      }, null, 8, ["items", "modelValue", "rules"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.isTreatment || _ctx.isCustodyResidential || _ctx.isSchool)
                                        ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "4"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.isTreatment)
                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                        key: 0,
                                                        items: _ctx.providerList,
                                                        "item-value": "providerId",
                                                        "item-title": "name",
                                                        label: "Provider",
                                                        modelValue: _ctx.entry.providerId,
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entry.providerId) = $event))
                                                      }, null, 8, ["items", "modelValue"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.isCustodyResidential)
                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                        key: 1,
                                                        items: _ctx.crTypeList,
                                                        "item-value": "value",
                                                        "item-title": "title",
                                                        label: "Type",
                                                        modelValue: _ctx.entry.custodyOrResidential,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.entry.custodyOrResidential) = $event)),
                                                        rules: _ctx.isCustodyResidential ? _ctx.requiredRules : []
                                                      }, null, 8, ["items", "modelValue", "rules"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.isSchool)
                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                        key: 2,
                                                        items: _ctx.attendanceList,
                                                        "item-value": "id",
                                                        "item-title": "description",
                                                        label: "Attendance Type",
                                                        modelValue: _ctx.entry.attendanceStatusId,
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.entry.attendanceStatusId) = $event)),
                                                        rules: _ctx.isSchool ? _ctx.requiredRules : []
                                                      }, null, 8, ["items", "modelValue", "rules"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "8"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.showProviderOther)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                        key: 0,
                                                        type: "text",
                                                        label: "Provider Name",
                                                        modelValue: _ctx.entry.providerOther,
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.entry.providerOther) = $event)),
                                                        rules: _ctx.showProviderOther ? _ctx.requiredRules : []
                                                      }, null, 8, ["modelValue", "rules"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.isCustodyResidential)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                        key: 1,
                                                        type: "text",
                                                        label: "Location",
                                                        modelValue: _ctx.entry.location,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.entry.location) = $event))
                                                      }, null, 8, ["modelValue"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.isSupervision)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                        key: 2,
                                                        type: "text",
                                                        label: "Supervisor Name",
                                                        modelValue: _ctx.entry.supervisorName,
                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.entry.supervisorName) = $event))
                                                      }, null, 8, ["modelValue"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }),
                                              (_ctx.isTreatment)
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 0,
                                                    cols: "12",
                                                    md: "4"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        type: "number",
                                                        modelValue: _ctx.entry.minutes,
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.entry.minutes) = $event)),
                                                        label: "Minutes"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.isBehaviorResponse)
                                        ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "8"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_autocomplete, {
                                                    multiple: "",
                                                    clearable: "",
                                                    items: _ctx.behaviorTypeList,
                                                    "item-value": "id",
                                                    "item-title": "description",
                                                    label: "Behaviors",
                                                    modelValue: _ctx.entry.behaviorIds,
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.entry.behaviorIds) = $event)),
                                                    rules: _ctx.isBehaviorResponse ? _ctx.multiSelectRules : []
                                                  }, null, 8, ["items", "modelValue", "rules"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "4"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.showOtherBehaviorType)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                        key: 0,
                                                        type: "text",
                                                        label: "Other Behavior Type",
                                                        modelValue: _ctx.entry.behaviorTypeOther,
                                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.entry.behaviorTypeOther) = $event)),
                                                        rules: _ctx.showOtherBehaviorType ? _ctx.requiredRules : []
                                                      }, null, 8, ["modelValue", "rules"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.isBehaviorResponse)
                                        ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "8"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_autocomplete, {
                                                    multiple: "",
                                                    clearable: "",
                                                    items: _ctx.responseTypeList,
                                                    "item-value": "id",
                                                    "item-title": "description",
                                                    label: "Responses",
                                                    modelValue: _ctx.entry.responseIds,
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.entry.responseIds) = $event)),
                                                    rules: _ctx.isBehaviorResponse ? _ctx.multiSelectRules : []
                                                  }, null, 8, ["items", "modelValue", "rules"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "4"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.showOtherResponseType)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                        key: 0,
                                                        type: "text",
                                                        label: "Other Response Type",
                                                        modelValue: _ctx.entry.behaviorResponseTypeOther,
                                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.entry.behaviorResponseTypeOther) = $event)),
                                                        rules: _ctx.showOtherResponseType ? _ctx.requiredRules : []
                                                      }, null, 8, ["modelValue", "rules"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.isDrugTest)
                                        ? (_openBlock(), _createBlock(_component_v_row, { key: 4 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "6"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.isDrugTest)
                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                        key: 0,
                                                        items: _ctx.drugTestSessionTypes,
                                                        "item-value": "id",
                                                        "item-title": "description",
                                                        label: "Session Type",
                                                        modelValue: _ctx.entry.drugTestSessionTypeId,
                                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.entry.drugTestSessionTypeId) = $event))
                                                      }, null, 8, ["items", "modelValue"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                md: "6"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.isDrugTest)
                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                        key: 0,
                                                        modelValue: _ctx.entry.drugTestMethodId,
                                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.entry.drugTestMethodId) = $event)),
                                                        items: _ctx.drugTestMethods,
                                                        "item-value": "id",
                                                        "item-title": "description",
                                                        label: "Method"
                                                      }, null, 8, ["modelValue", "items"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.isDrugTest)
                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                        key: 1,
                                                        modelValue: _ctx.entry.drugTestObservationId,
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.entry.drugTestObservationId) = $event)),
                                                        items: _ctx.drugTestObservations,
                                                        "item-value": "id",
                                                        "item-title": "description",
                                                        label: "Observed"
                                                      }, null, 8, ["modelValue", "items"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.isEmployment || _ctx.isDrugTest)
                                        ? (_openBlock(), _createBlock(_component_v_row, { key: 5 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  (_ctx.isEmployment)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                        key: 0,
                                                        type: "text",
                                                        label: "Employer Name",
                                                        modelValue: _ctx.entry.employerName,
                                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.entry.employerName) = $event)),
                                                        rules: _ctx.isEmployment ? _ctx.requiredRules : []
                                                      }, null, 8, ["modelValue", "rules"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.isDrugTest)
                                                    ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                                                        key: 1,
                                                        multiple: "",
                                                        clearable: "",
                                                        items: _ctx.drugTestTypes,
                                                        "item-value": "id",
                                                        "item-title": "description",
                                                        label: "Type",
                                                        modelValue: _ctx.entry.drugTestTypeIds,
                                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.entry.drugTestTypeIds) = $event))
                                                      }, null, 8, ["items", "modelValue"]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.isDrugTest)
                                                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                        key: 2,
                                                        modelValue: _ctx.entry.performedBy,
                                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.entry.performedBy) = $event)),
                                                        label: "Test Performed By"
                                                      }, null, 8, ["modelValue"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_textarea, {
                                        modelValue: _ctx.entry.notes,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.entry.notes) = $event)),
                                        label: "Notes",
                                        rows: "3"
                                      }, null, 8, ["modelValue"]),
                                      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "text-red" }, " *Batch entry data will be entered to the participant's Phase based on the entry's Start Date ", -1)),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              (_ctx.hasUploadAccess)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 0,
                                                    color: "primary",
                                                    onClick: _ctx.onDataUploadClick
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                                      _createTextVNode("Data Upload", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_spacer),
                                          (_ctx.hasUploadAccess)
                                            ? (_openBlock(), _createBlock(_component_BatchUploadModal, {
                                                key: 0,
                                                showDialog: _ctx.showBulkDataUploadModal,
                                                onClose: _cache[28] || (_cache[28] = () => _ctx.showBulkDataUploadModal = false),
                                                onPreparedDataUpload: _ctx.onCsvDataUpload
                                              }, null, 8, ["showDialog", "onPreparedDataUpload"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    lg: "4",
                                    class: "bg-white"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_toolbar, {
                                        color: "secondary",
                                        class: "mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                                            default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                              _createTextVNode("Participant Search", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchOptions, (option) => {
                                            return (_openBlock(), _createBlock(_component_v_col, {
                                              cols: "12",
                                              sm: "6",
                                              key: option.key
                                            }, {
                                              default: _withCtx(() => [
                                                (option.type == 'select')
                                                  ? (_openBlock(), _createBlock(_component_v_select, {
                                                      key: 0,
                                                      multiple: "",
                                                      items: _ctx.getLookupList(option.lookupKey),
                                                      "item-value": "id",
                                                      "item-title": "description",
                                                      modelValue: _ctx.searchDto[option.key],
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.searchDto[option.key]) = $event),
                                                      label: option.name,
                                                      onKeyup: _withKeys(_ctx.getResults, ["enter"])
                                                    }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "label", "onKeyup"]))
                                                  : (_openBlock(), _createBlock(_component_v_text_field, {
                                                      key: 1,
                                                      modelValue: _ctx.searchDto[option.key],
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.searchDto[option.key]) = $event),
                                                      label: option.name,
                                                      type: option.type,
                                                      "hide-details": "",
                                                      color: "white",
                                                      onKeyup: _withKeys(_ctx.getResults, ["enter"])
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "type", "onKeyup"]))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchValidationResults, (result, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              class: "error",
                                              key: index
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(result), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            align: "center",
                                            class: "mb-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "ma-2",
                                                color: "info",
                                                onClick: _ctx.getResults
                                              }, {
                                                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                  _createTextVNode("Search", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["onClick"])), [
                                                [_directive_ripple]
                                              ]),
                                              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "ma-2",
                                                color: "secondary",
                                                onClick: _ctx.clearSearch
                                              }, {
                                                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                                  _createTextVNode("Clear Search", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["onClick"])), [
                                                [_directive_ripple]
                                              ]),
                                              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                class: "ma-2",
                                                color: "secondary",
                                                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.partSearchDialog = false))
                                              }, {
                                                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                                  _createTextVNode("Close", -1)
                                                ]))]),
                                                _: 1
                                              })), [
                                                [_directive_ripple]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, { class: "mb-4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { align: "center" }, {
                                            default: _withCtx(() => [
                                              (_ctx.isLoadingResults)
                                                ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                                                : (_openBlock(), _createBlock(_component_v_data_table, {
                                                    key: 1,
                                                    headers: _ctx.headers,
                                                    items: _ctx.searchResults,
                                                    density: "compact",
                                                    class: "elevation-1",
                                                    "no-data-text": "No results available"
                                                  }, {
                                                    [`item.name`]: _withCtx(({ item }) => [
                                                      _createTextVNode(_toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1)
                                                    ]),
                                                    [`item.actions`]: _withCtx(({ item }) => [
                                                      _createVNode(_component_v_btn, {
                                                        onClick: ($event: any) => (_ctx.selectParticipant(item)),
                                                        density: "comfortable",
                                                        size: "small",
                                                        icon: "mdi-plus",
                                                        color: "info"
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    bottom: _withCtx(() => [...(_cache[43] || (_cache[43] = []))]),
                                                    _: 2
                                                  }, 1032, ["headers", "items"]))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  false
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            color: "primary",
                                            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.partSearchDialog = true))
                                          }, {
                                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                              _createTextVNode("Open Participant Search", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("template", null, [
                                    _createVNode(_component_v_dialog, {
                                      modelValue: _ctx.partSearchDialog,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.partSearchDialog) = $event)),
                                      scrollable: "",
                                      width: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, { class: "text-white pageHeader bg-secondary" }, {
                                              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                                _createTextVNode("Participant Search", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_divider),
                                            _createVNode(_component_v_card_text)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_toolbar, {
                                        color: "secondary",
                                        class: "mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                                            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                              _createTextVNode("Selected Participants", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_data_table, {
                                        headers: _ctx.participantHeaders,
                                        items: _ctx.entry.participants,
                                        density: "compact",
                                        class: "elevation-1",
                                        "no-data-text": "No participants selected"
                                      }, _createSlots({
                                        [`item.status`]: _withCtx(({ item }) => [
                                          _createVNode(_component_v_select, {
                                            modelValue: item.statusId,
                                            "onUpdate:modelValue": ($event: any) => ((item.statusId) = $event),
                                            items: _ctx.statusList,
                                            "item-value": "id",
                                            "item-title": "description",
                                            label: "Select Status",
                                            rules: _ctx.statusList.length > 0 ? _ctx.requiredRules : []
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                                        ]),
                                        [`item.phaseStartDate`]: _withCtx(({ item }) => [
                                          _createTextVNode(_toDisplayString(_ctx.formatDate(item.phaseStartDate)), 1)
                                        ]),
                                        [`item.phaseEndDate`]: _withCtx(({ item }) => [
                                          _createTextVNode(_toDisplayString(_ctx.formatDate(item.phaseEndDate)), 1)
                                        ]),
                                        [`item.actions`]: _withCtx(({ item }) => [
                                          _createVNode(_component_v_btn, {
                                            onClick: ($event: any) => (_ctx.removeParticipant(item.participantId)),
                                            density: "comfortable",
                                            size: "small",
                                            icon: "mdi-trash-can-outline",
                                            color: "error"
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, [
                                        (_ctx.isDrugTest)
                                          ? {
                                              name: `item.drugTest`,
                                              fn: _withCtx(({ item }) => [
                                                _createVNode(_component_v_select, {
                                                  items: _ctx.drugTestResults,
                                                  "item-value": "id",
                                                  "item-title": "description",
                                                  label: "Result",
                                                  modelValue: item.drugTestResultId,
                                                  "onUpdate:modelValue": ($event: any) => ((item.drugTestResultId) = $event)
                                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                                              ]),
                                              key: "0"
                                            }
                                          : undefined
                                      ]), 1032, ["headers", "items"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.saveResults)
                        ? (_openBlock(), _createBlock(_component_ValidationAlert, {
                            key: 0,
                            "validation-results": _ctx.saveResults.messages
                          }, null, 8, ["validation-results"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, { class: "mt-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { align: "center" }, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                color: "primary",
                                onClick: _ctx.save,
                                disabled: _ctx.entry.participants.length == 0 || _ctx.isSaving
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])), [
                                [_directive_ripple]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}